export const oldKeys = [
	['C', 'B#'],
	['Db', 'C#'],
	['D', 'D'],
	['Eb', 'D#'],
	['Fb', 'E'],
	['F', 'E#'],
	['F#', 'Gb'],
	['G', 'G'],
	['Ab', 'G#'],
	['A', 'A'],
	['Bb', 'A#'],
	['Cb', 'B']
]

export const newKeys = [
	['C', 'C'],
	['Db', 'C#'],
	['D', 'D'],
	['Eb', 'D#'],
	['E', 'E'],
	['F', 'F'],
	['Gb', 'F#'],
	['G', 'G'],
	['Ab', 'G#'],
	['A', 'A'],
	['Bb', 'A#'],
	['B', 'B']
]